import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";

export default function SafetyTips({
  customClass = "",
  card1,
  card2,
  card3,
  singleLine1,
  singleLine2,
  logo1,
  logo2,
  logo3,
}) {
  return (
    <section id='SafetyTips' className={`${styles.root} ${customClass}`}>
      <Container>
        <h1>Safety tips</h1>
        <span>These simple steps can help you feel safer travelling to and from work.</span>
        <div className="content-wrapper p-lg-5 p-4 rounded-3 mt-3">

          {/* Row 1: Card 1 | Logo 1 | Single Line 1 */}
          <Row className="align-items-center mb-5">
            <Col xl={5} sm={12}>
              <div className="safety-card">
                {card1}
              </div>
            </Col>
            <Col xl={2} sm={12} className="d-flex justify-content-center">
              <div className="safety-logo">
                <img src={logo1} alt="" />
              </div>
            </Col>
            <Col xl={5} sm={12}>
              <div className="safety-single-line">
                {singleLine1}
              </div>
            </Col>
          </Row>

          {/* Row 2: Logo 2 | Single Line 2 | Card 2 */}
          <Row className="align-items-center mb-5">
            <Col xl={2} sm={12} className="d-flex justify-content-center">
              <div className="safety-logo">
                <img src={logo2} alt="" />
              </div>
            </Col>
            <Col xl={5} sm={12}>
              <div className="safety-single-line safety-single-line--2">
                {singleLine2}
              </div>
            </Col>
            <Col xl={5} sm={12}>
              <div className="safety-card">
                {card2}
              </div>
            </Col>
          </Row>

          {/* Row 3: Card 3 | Logo 3 */}
       {/* Row 3: Card 3 | Logo 3 */}
<Row className="align-items-end">
  <Col xl={5} sm={12}>
    <div className="safety-card">
      {card3}
    </div>
  </Col>
  <Col xl={2} xlo={1} sm={12} className="d-flex justify-content-center offset-xl-1">
    <div className="safety-logo safety-logo--bottom">
      <img src={logo3} alt="" />
    </div>
  </Col>
</Row>

        </div>
      </Container>
    </section>
  );
}